import { Pipe, PipeTransform } from '@angular/core';

function checkFormat(phone: string) {
  const regEx = new RegExp(/^[0-9]{10}$/);
  if (regEx.test(phone)) {
    return true;
  }
  return false;
}

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {

  // Phone number must be a string with 10 digits only
  transform(phone: string): any {
    let newPhone: string;

    if (phone) {
      if (checkFormat(phone)) {
        const areaCode = phone.slice(0, 3);
        const firstThree = phone.slice(3, 6);
        const lastFour = phone.slice(6);
        newPhone = `(${areaCode}) ${firstThree}-${lastFour}`;
      } else {
        newPhone = phone;
      }
    }

    return newPhone;
  }

}
